import React, { Component } from 'react';
import ImageBackground from '../common/imageBackground';
import ImageHeader from '../common/imageHeader';
import NavigationBar from '../common/navigationBar';

export default class PlayingMusic extends Component {
  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1230">
        <ImageBackground id="background" />
        <ImageHeader {...this.props.header} />
        <NavigationBar {...this.props.navigationBar} />
      </div>
    );
  }
}
